import { useEffect, useRef, type JSX } from 'react';

interface VoiceCaptureAudioPreviewProps {
  readonly label: string;
  readonly src: string;
}

export function VoiceCaptureAudioPreview({
  label,
  src,
}: VoiceCaptureAudioPreviewProps): JSX.Element {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    // Mobile Safari can use the first press on a newly-created Blob URL only
    // to load the media. Prime every new recording so that press plays audio.
    audioRef.current?.load();
  }, [src]);

  return <audio ref={audioRef} aria-label={label} controls playsInline preload="auto" src={src} />;
}
